

export const constructionOne = {
	reverse: false,
	inverse: false,
	topLine: {
		text: '',
	},
	headline: 'Página en construcción',
	description: '',
	buttonLabel: 'Volver',

	linkTo: '/',
	redir: null,
	imgStart: 'start',
	img: './assets/svg/Connection.svg',
	start: 'true',
};

/*
export const constructionTwo = {
	reverse: true,
	inverse: true,
	topLine: {
		text: 'Nos iniciamos en el año 1991',
	},
	headline: "Más de tres décadas en el negocio",
	description: 'Contamos con la experiencia y el respaldo de empresas lideres.',
	buttonLabel: 'Conócenos',

	linkTo: '/quienes-somos',
	redir: null,
	imgStart: 'start',
	img: './assets/svg/Deal.svg',
	start: 'true',
};

export const constructionThree = {
	reverse: true,
	inverse: true,
	topLine: {
		text: 'Highly reputed brand',
	},
	headline: 'Why us? ',
	description:
		'Our 9 year experience have allowed us to use the most innovative technologies and methodologies',
	buttonLabel: 'View Project',

	linkTo: null,
	redir: null,
	imgStart: '',
	img: './assets/svg/ChartUp.svg',
	start: 'true',
};*/
